import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26fc9468"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"60px"} }, "回答数", -1))
const _hoisted_4 = { style: {"width":"80px"} }
const _hoisted_5 = { class: "gage" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"60px"} }, "時間", -1))
const _hoisted_8 = { style: {"width":"80px"} }
const _hoisted_9 = { class: "gage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.qIndex - 1) + "／" + _toDisplayString(_ctx.data.length) + "問", 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "gage-content",
            style: _normalizeStyle('width:' + (_ctx.gagedata2 * 450) + 'px')
          }, null, 4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.restMinutes) + "／" + _toDisplayString(_ctx.allMinutes) + "分", 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "gage-content",
          style: _normalizeStyle('width:' + (_ctx.gagedata1 * 450) + 'px')
        }, null, 4)
      ])
    ])
  ], 64))
}